import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Suppress the benign ResizeObserver loop error that webpack-dev-server
// surfaces as an overlay. This error comes from Mantine internals and
// does not affect functionality.
window.addEventListener('error', (e) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
    const overlay = document.getElementById('webpack-dev-server-client-overlay');
    const overlayDiv = document.getElementById('webpack-dev-server-client-overlay-div');
    if (overlay) overlay.style.display = 'none';
    if (overlayDiv) overlayDiv.style.display = 'none';
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
